import { useFieldContext } from "../form-context";

import { JSX } from "react";
import { useTranslation } from "react-i18next";

import { Checkbox, SxProps } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";

import { BaseField } from "./BaseField";

export interface CheckboxFieldProps {
  sx?: SxProps;
  fullWidth?: boolean;
  required?: boolean;
}

export function CheckboxField({
  sx,
  fullWidth,
  required,
}: CheckboxFieldProps = {}): JSX.Element {
  const { t } = useTranslation();
  const field = useFieldContext<Record<string, boolean>>();
  const values = field.state.value;

  return (
    <BaseField
      sx={sx}
      fullWidth={fullWidth}
      required={required}
      showError={false}
    >
      <FormGroup sx={{ display: "flex", flexDirection: "row" }}>
        {Object.entries(values).map(([key, value]) => (
          <FormControlLabel
            key={key}
            control={
              <Checkbox
                onBlur={field.handleBlur}
                checked={value}
                onChange={(_, checked) =>
                  field.handleChange((prev) => ({
                    ...prev,
                    [key]: checked,
                  }))
                }
              />
            }
            label={t(
              `AS:dialog.requestQuote.checkbox.${field.name}.option.${key}`,
            )}
          />
        ))}
      </FormGroup>
    </BaseField>
  );
}
